import {Component, OnDestroy, OnInit} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {Router} from '@angular/router';
import * as moment from 'moment';
import {MY_FORMATS} from 'src/app/constants/datapicker';
import {MyErrorHandler} from 'src/app/constants/error';
import {GenericConfirmationComponent} from 'src/app/modal/generic-confirmation/generic-confirmation.component';
import {ModalErrorComponent} from 'src/app/modal/modal-gestioneErrori/modal-error/modal-error.component';
import {ModalSuccessComponent} from 'src/app/modal/modal-gestioneErrori/modal-success/modal-success.component';
import {Event, EventCategory, EventDate, EventGroup, OpeningMode, Ship, TimeType} from 'src/app/model';
import {ROUTES} from 'src/app/route/routes';
import {EventService} from 'src/app/services/event.service';
import {environment} from 'src/environments/environment';
import {EventSlotsModalComponent} from '../../../modal/modal-event/event-slots-modal/event-slots-modal.component';
import {SpinnerService} from 'src/app/_components/spinner/spinner.service';
import {FormControl} from '@angular/forms';
import {Observable, Subject} from 'rxjs';
import {TIMERELATIVEOPTIONS, TIMETYPEOPTIONS} from 'src/app/constants/times';
import {UserService} from "../../../services/user.service";
import {takeUntil} from 'rxjs/operators';

@Component({
  selector: 'app-event-edit',
  templateUrl: './event-edit.component.html',
  styleUrls: ['./event-edit.component.scss'],
  standalone: false
})
export class EventEditComponent implements OnInit, OnDestroy {

  // For robust subscription management
  private ngUnsubscribe = new Subject<void>();
  myControl = new FormControl();

  optionsRelativeTime: Array<TimeType> = TIMERELATIVEOPTIONS;
  selectedTimeRelativeChiusura: TimeType = TIMERELATIVEOPTIONS[0];
  selectedTimeRelativeChiusuraWL: TimeType = TIMERELATIVEOPTIONS[0];

  optionsTypeTime: Array<TimeType> = TIMETYPEOPTIONS;
  selectedTimeTypeApertura: TimeType = TIMETYPEOPTIONS[0];
  selectedTimeTypeChiusura: TimeType = TIMETYPEOPTIONS[0];
  selectedTimeTypeChiusuraWL: TimeType = TIMETYPEOPTIONS[0];

  filteredOptions!: Observable<string[]>;
  selectedLangTitle: string = 'en';
  selectedLangShort: string = 'en';
  selectedLangLong: string = 'en';

  maxPerPassengerReservableLabel: number =
    environment.constantMaxReservationsPerEvent;

  eventModel: Event = new Event();
  group: EventGroup = new EventGroup("");
  allEvents: Array<Event> = [];
  eventSelected: Event | null = null;
  selectedShip: Ship | null = null;
  availableShips: Array<Ship> = [];
  openingModeEnum = OpeningMode;
  selectedMode: OpeningMode | undefined = OpeningMode.FIRST_OCCURRENCE;
  minDate = new Date();
  date: Date | undefined = new Date();
  listCategory: Array<EventCategory> = [];

  constructor(
    private router: Router,
    private dialog: MatDialog,
    private eventService: EventService,
    private userService: UserService,
    private spinner: SpinnerService
  ) {}

  ngOnInit(): void {
    this.getAllCategories();
    this.getAvailableShips();
    if (this.availableShips.length === 1) {
      this.selectedShip = this.availableShips[0];
      this.onShipSelectionChange();
    }

    // this.getAllLocations();
    // this.filteredOptions = this.myControl.valueChanges.pipe(
    //   // startWith(''),
    //   map(value => this._filter(value)),
    // );
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  onShipSelectionChange(): void {
    this.allEvents = [];
    this.eventSelected = null;
    this.eventModel = new Event();
    if (this.selectedShip) {
      this.getFilteredEvents(this.selectedShip.id_ship);
    }
  }

  getFilteredEvents(shipId: string) {
    this.spinner.show();

    this.eventService.getAllEvents(true, shipId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (res: Event[]) => {
          this.allEvents = res.map(raw  => {
            const ev = new Event();
            ev.convertToFE(raw);
            return ev;
          });
        },
        error: (err) => {
          this.showError(err);
          this.spinner.hide();
        },
        complete: () => {
          this.spinner.hide();
        }
      });
  }

  // private _filter(value: string): string[] {
  //   const filterValue = value.toLowerCase();
  //   return this.options.filter(option => option.toLowerCase().includes(filterValue));
  // }

  // getAllLocations() {
  //   this.eventService.getLocations().subscribe({
  //     next: (res) => {
  //       this.options = res;
  //       this.spinner.hide();
  //     },
  //     error: (err) => {
  //       this.spinner.hide();
  //     },
  //   });
  // }
  getAvailableShips() {
    this.availableShips = this.userService.ships ? this.userService.ships : [];
  }


  getAllCategories() {
    this.spinner.show();
    this.eventService.getAllCategories().subscribe({
      next: (res) => {
        this.listCategory = res;
      },
      error: _  => this.spinner.hide(),
      complete: () => {
        this.spinner.hide();
      }
    });
  }

  addGroup(elm: EventGroup) {
    if (elm && elm.id_group.length >=3 && elm.id_group.length <= 50) {
      let existGroup = this.eventModel.event_groups?.find((group) => {
        return group.id_group == elm.id_group;
      });
      if (!existGroup) {
        this.eventModel.event_groups?.push({
          id_group: elm.id_group,
        });
      }
      elm.id_group = '';
    }
  }

  addDate(elm: Date | undefined) {
    if (elm) {
      const newMomentDate = moment(elm, MY_FORMATS.parse.dateInput).startOf('day');
      const existDate = this.eventModel.event_dates?.find(event => {
        return moment(event.date).isSame(newMomentDate, 'day');
      });
      if (!existDate) {
        let eventDate: EventDate = new EventDate();
        eventDate.date = newMomentDate.toDate();
        this.eventModel.event_dates = [...this.eventModel.event_dates!, eventDate];
      }
    }
    this.date = undefined;
  }

  removeGroup(index: number) {
    this.eventModel.event_groups?.splice(index, 1);
  }

  removeDate(dateToRemove: EventDate) {
    this.eventModel.event_dates = this.eventModel.event_dates?.filter(
      eventDate => eventDate !== dateToRemove
    );
  }

  goTo(path: string) {
    switch (path) {
      case 'home':
        this.router.navigate([ROUTES.HOME.path]);
        break;
      case 'landing':
        this.router.navigate([ROUTES.EVENT.path]);
        break;
      case 'here':
        this.router.navigate([ROUTES.EVENT_EDIT.path]);
        break;
    }
  }

  isSearchDisabled() {
    return !this.eventSelected;
  }

  search() {
    if (!this.eventSelected || !this.eventSelected.uuid_event) return;
    this.spinner.show();

    let uuid = this.eventSelected.uuid_event;

    this.eventService.getEvent(uuid).subscribe({
      next: (res) => {
        this.eventModel = new Event();
        this.eventModel.convertToFE(res);
        this.selectedMode = OpeningMode.fromString(this.eventModel.event_opening_mode!);
        if (this.isNegative(this.eventModel.end_time_reservable_before_slot!)) {
          this.selectedTimeRelativeChiusura = TIMERELATIVEOPTIONS[1];
          this.eventModel.end_time_reservable_before_slot = Math.abs(
            this.eventModel.end_time_reservable_before_slot!
          );
        }

        if (this.isNegative(this.eventModel.waiting_list_end_time!)) {
          this.selectedTimeRelativeChiusuraWL = TIMERELATIVEOPTIONS[1];
          this.eventModel.waiting_list_end_time = Math.abs(
            this.eventModel.waiting_list_end_time!
          );
        }

        this.selectedTimeTypeApertura = this.whatIsThisNumber(
          this.eventModel.time_reservable_before_slot!
        );
        this.selectedTimeTypeChiusura = this.whatIsThisNumber(
          this.eventModel.end_time_reservable_before_slot!
        );
        this.selectedTimeTypeChiusuraWL = this.whatIsThisNumber(
          this.eventModel.waiting_list_end_time!
        );

        this.eventModel.time_reservable_before_slot! /=
          this.selectedTimeTypeApertura.multiplier;
        this.eventModel.end_time_reservable_before_slot! /=
          this.selectedTimeTypeChiusura.multiplier;
        this.eventModel.waiting_list_end_time! /=
          this.selectedTimeTypeChiusuraWL.multiplier;

        // this._filter(res.event_location!);
        this.spinner.hide();
      },
      error: (err) => {
        this.showError(err);
        this.spinner.hide();
      },
    });
  }

  private isNegative(num: number) {
    return Math.sign(num) === -1;
  }

  private whatIsThisNumber(num: number) {
    if (this.isHours(num)) {
      if (this.isDays(num)) {
        return TIMETYPEOPTIONS[2];
      }

      return TIMETYPEOPTIONS[1];
    }

    return TIMETYPEOPTIONS[0];
  }

  private isHours(num: number) {
    return num % 60 === 0;
  }

  private isDays(num: number) {
    return num % (60 * 24) === 0;
  }

  openSettingsSlots(event_date: EventDate, isSpaCategory: boolean) {
    const dialogRef = this.dialog.open(EventSlotsModalComponent, {
      data: {
        inputSlots: event_date.event_slots,
        isSpaCategory: isSpaCategory,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        event_date.event_slots = result;
      }
    });
  }

  isValidEventDates() {
    if (!this.eventModel.event_dates || this.eventModel.event_dates.length == 0)
      return false;
    let isValid = true;
    let eventDates: EventDate[] = this.eventModel.event_dates;
    eventDates.forEach((eventDate) => {
      if (isValid) {
        let tmpDate = new Date();
        tmpDate.setDate(this.minDate.getDate() - 1);
        if (
          !eventDate.date ||
          //|| eventDate.date < this.minDate // Rimosso nella pagina di UPDATE, per permettere l'esistenza delle vecchie date
          !eventDate.event_slots ||
          eventDate.event_slots.length == 0
        ) {
          isValid = false;
        }
      }
    });
    return isValid;
  }

  requiredLangs(): boolean {
    return (
      this.eventModel.event_name_en != undefined &&
      this.eventModel.event_name_en.length > 0 &&
      this.eventModel.event_short_description_en != undefined &&
      this.eventModel.event_short_description_en.length > 0 &&
      this.eventModel.event_long_description_en != undefined &&
      this.eventModel.event_long_description_en.length > 0
    );
  }

  isSaveDisabled(): boolean {
    return !this.isValidEventDates();
  }

  isFluxSpa(category: string): boolean {
    if (!category) return false;

    const foundCategory = this.listCategory.find(
      (cat) => cat.id_event_category.toString() == category
    );

    return !!foundCategory && foundCategory.flux == 'spa';
  }

  save() {
    if (!this.eventModel.uuid_event) return;
    this.spinner.show();

    if (!this.isFluxSpa(this.eventModel.fk_event_category?.toString() || '')) {
      const dates = this.eventModel.event_dates
        ? this.eventModel.event_dates
        : [];
      dates.forEach((date) => {
        if (date?.event_slots) {
          date.event_slots.forEach((slot) => {
            if (!slot.detail) {
              slot.detail = '';
            }
          });
        }
      });
    }

    let body: Event = this.eventModel.convertToBE(
      this.selectedTimeRelativeChiusura,
      this.selectedTimeRelativeChiusuraWL,
      this.selectedTimeTypeApertura,
      this.selectedTimeTypeChiusura,
      this.selectedTimeTypeChiusuraWL,
      this.selectedMode!
    );
    let uuid = this.eventModel.uuid_event;

    delete body.uuid_event;

    this.eventService.updateSingleEvent(body, uuid).subscribe({
      next: () => {
        this.showSuccess();
      },
      error: (err) => {
        this.showError(err);
        this.spinner.hide();
      },
    });
  }

  delete() {
    const dialogRef = this.dialog.open(GenericConfirmationComponent, {
      data: {
        message:
          "Vuoi confermare la cancellazione dell'evento? Tutte le prenotazioni verranno cancellate.",
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result && this.eventModel?.uuid_event) {
        this.spinner.show();
        this.eventService
          .deleteSingleEvent(this.eventModel.uuid_event)
          .subscribe(
            () => {
              this.showSuccess();
            },
            (err) => {
              this.showError(err);
              this.spinner.hide();
            }
          );
      }
    });
  }

  computeMaxClosing(): number {
    // se la chiusura è prima dell'inizio, deve avvenire dopo l'apertura
    if (this.selectedTimeRelativeChiusura.code == 0) {
      return this.eventModel.time_reservable_before_slot
        ? this.eventModel.time_reservable_before_slot - 1
        : 0;
    } else {
      // se la chiusura è dopo l'inizio dell'evento, può avvenire fino a 1gg dopo
      return 24; // 1 gg
    }
  }

  private showSuccess() {
    this.spinner.hide();

    const dialogRef = this.dialog.open(ModalSuccessComponent);

    dialogRef.afterClosed().subscribe(() => {
      this.goTo('landing');
    });
  }

  private showError(err: any) {
    this.spinner.hide();

    const dialogRef = this.dialog.open(ModalErrorComponent, {
      data: MyErrorHandler.getText(err),
    });

    dialogRef.afterClosed().subscribe(() => {
      this.goTo('here');
    });
  }
}
